import React, { useState } from 'react'
import {
  Box,
  Container,
  Tab,
  Tabs,
  Typography,
  Paper
} from '@mui/material'
import ReceiptIcon from '@mui/icons-material/Receipt'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import { useTranslation } from 'react-i18next'
import BillingTab from '../components/admin/BillingTab'
import CreditsTab from '../components/admin/CreditsTab'
import PricingTab from '../components/admin/PricingTab'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `admin-tab-${index}`,
    'aria-controls': `admin-tabpanel-${index}`,
  }
}

const AdminPage: React.FC = () => {
  const { t } = useTranslation()
  const [tabValue, setTabValue] = useState(0)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={0} sx={{ backgroundColor: 'transparent' }}>
        <Typography variant="h4" gutterBottom sx={{ color: 'white', mb: 3 }}>
          {t('adminPanel')}
        </Typography>

        <Paper sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="admin tabs"
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab
              icon={<ReceiptIcon />}
              iconPosition="start"
              label={t('billingManagement')}
              {...a11yProps(0)}
            />
            <Tab
              icon={<AccountBalanceWalletIcon />}
              iconPosition="start"
              label={t('walletCredits')}
              {...a11yProps(1)}
            />
            <Tab
              icon={<LocalOfferIcon />}
              iconPosition="start"
              label={t('customPricing')}
              {...a11yProps(2)}
            />
          </Tabs>

          <TabPanel value={tabValue} index={0}>
            <BillingTab />
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <CreditsTab />
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <PricingTab />
          </TabPanel>
        </Paper>
      </Paper>
    </Container>
  )
}

export default AdminPage
